<template>
  <div>
    <!-- 历史打印标签 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="780px" center>
      <div class="content">

        <div class="table">
          <ol>
            <!-- 申请人 -->
            <li>
              {{ $t("message.theApplicant") }}
            </li>
            <!-- 申请时间 -->
            <li>
              {{ $t("message.applyTime") }}
            </li>
            <!-- 申请数量 -->
            <li>
              {{ $t("message.applicationQuantity") }}
            </li>
            <!-- 申请原因 -->
            <li>
              {{ $t("message.reasonForApplication") }}
            </li>

          </ol>
          <ul v-for="(item, index) in porder_detail_tag_print" :key="index">
            <!-- 申请人 -->
            <li>
              {{ item.created_admin.realname }}
            </li>
            <!-- 申请时间 -->
            <li>
              {{ item.created_at }}
            </li>
            <!-- 申请数量 -->
            <li>
              {{ item.num }}
            </li>
            <!-- 申请原因 -->
            <li>
              {{ item.print_reason }}
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>

      </span>
    </el-dialog>
  </div>
</template>
<script>


export default {
  props: {
    porder_detail_tag_print: { type: Array },
  },
  data() {
    return {

      dialogVisible: false,
    };
  },
  methods: {

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
    }

    .val {
      flex: 3;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border: 0;
      }

      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 60%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>